import React from "react";
import styles from "../styles/ProcessStep.module.css";

const ProcessStep = ({ number, title, description, isHighlighted = false }) => {
  return (
    <div
      className={`${styles.step} ${isHighlighted ? styles.highlighted : ""}`}
    >
      <div className={styles.stepNumber}>{number}</div>
      <h3 className={styles.stepTitle}>{title}</h3>
      <p className={styles.stepDescription}>{description}</p>
    </div>
  );
};

export default ProcessStep;
